import { priorityMap, statusMap } from "../../../../utils/options";

export function TicketInfoCard({ attributes, ticket, title, status, description, priority, branch, solutionApplied, typeService, serviceImage, creationDate, assigneeName }) {

    const getPriority = (priority) => priorityMap[priority]?.value || 'desconhecido';
    const getPriorityLabel = (priority) => priorityMap[priority]?.label || 'Desconhecido';

    const getStatus = (status) => statusMap[status]?.value || 'desconhecido';
    const getStatusLabel = (status) => statusMap[status]?.label || 'Desconhecido';

    const returnAttribute = (data) => {
        switch (data) {
            case 'true':
                return 'Sim';
            case 'false':
                return "Não";
            default:
                return data;
        }
    }

    return (
        <div className={`bg-white rounded-lg shadow p-6 priority-${getPriority(priority)}`}>
            <div className="flex justify-between items-start mb-4">
                <h2 className="text-xl font-bold text-gray-800">{title}</h2>
                <span className={`status-badge text-xs font-semibold px-2 py-1 rounded-full status-${getStatus(status)}`}>
                    {getStatusLabel(status)}
                </span>
            </div>

            <p className="text-gray-600 mb-6">
                {description}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <Info title="Número do Chamado" content={ticket} icon="fas fa-ticket-alt text-gray-500" />
                <Info title="Data de Abertura" content={creationDate} icon="far fa-clock text-gray-500" />
                <Info title="Prioridade" content={getPriorityLabel(priority)} icon={`fas fa-exclamation-circle text-${getPriority(priority)}-500`} />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="col-span-1">
                    <Info
                        title="Filial"
                        content={branch}
                        icon="fas fa-map-marker-alt text-indigo-500"
                    />
                </div>
                <div className="col-span-1 md:col-span-2">
                    <Info
                        title="Tipo de Serviço"
                        content={typeService}
                    />
                </div>
            </div>

            {Object.entries(attributes).length > 0 &&
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    {Object.entries(attributes)
                        .sort((a, b) => {
                            const titleA = a[0].split("___")[1] || "";
                            const titleB = b[0].split("___")[1] || "";
                            return titleA.localeCompare(titleB);
                        })
                        .map((obj) => (
                            <Info
                                key={obj[0]}
                                title={obj[0].split("___")[1] || obj[0]}
                                content={returnAttribute(obj[1])}
                                type={obj[0].split("___")[0]}
                            />
                        ))}
                </div>
            }
            {status === "RESOLVIDO" &&
                <div className="flex col-md-12 mb-6">
                    <Info title="Solução aplicada" content={solutionApplied.split('\n').map((line) => (
                        <>{line}<br /></>
                    ))} icon="fas fa-message text-indigo-500 " />
                </div>
            }

            {assigneeName !== null &&
                <div className="border-t border-gray-200 pt-4">
                    <p className="text-sm text-gray-500 mb-2">Atribuído para</p>
                    <div className="flex items-center">
                        <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center mr-2">
                            <i className="fas fa-user text-indigo-600"></i>
                        </div>
                        <span className="text-gray-800">{assigneeName} (Analista de T.I)</span>
                    </div>
                </div>
            }
        </div>
    )
};

const Info = (props) => {
    return (
        <div>
            <p className="text-sm text-gray-500 mb-1">{props.title}</p>
            <p className="text-gray-800 flex items-center">
                {props.icon != null && <i className={`${props.icon} mr-2`}></i>}
                {props.content}
            </p>
        </div>
    )
}
